export const enTranslations = {
  landing: {
    title: "Grensa.AI – Artificial intelligence for support and sales agents",
  },
  navigation: {
    about: "About Widget",
    quickstart: "Quick Start",
    benefits: "Benefits",
    pricing: "Pricing",
  },
  buttons: {
    try: "Try Now",
    demoCall: "Demo Call",
  },
  top: {
    title: "Artificial intelligence for support and sales agents",
    caption:
      "Integration in 2 minutes. Grensa.AI integrates into your helpdesk, helps you find answers faster, comply with SLA, and work more efficiently without unnecessary effort.",
  },
  solutions: {
    title: "How can we help?",
    solutionText: [
      {
        title: "Many requests, little time",
        caption:
          "Grensa.AI analyzes your knowledge base and offers ready-made answers directly in the chat. The manager simply selects the needed option",
      },
      {
        title: "Managers lose conversation context",
        caption:
          "AI creates a brief summary so the manager can immediately understand what the conversation is about, without unnecessary rereading",
      },
      {
        title: "Overdue tickets and SLA violations",
        caption:
          "Reminds which tickets require urgent response, so SLA is not violated",
      },
      {
        title: "Inconsistent communication style and text errors",
        caption:
          "AI checks the tone and correctness of responses, highlights errors and suggests improvements",
      },
      {
        title: "Long learning curve for new tools",
        caption:
          "Integration takes 2 min. — install the extension and paste the link to your knowledge base",
      },
    ],
  },
  howToStart: {
    title: "How to get started?",
    caption: "Grensa.AI connects in 2 minutes",
    installTry: "Install and try",
    steps: [
      { title: "Install the extension", description: "" },
      { title: "Add a link to your knowledge base", description: "" },
      {
        title: "Send the link to colleagues",
        description: "They will connect automatically",
      },
      { title: "Done!", description: "" },
    ],
  },
  reasons: {
    title: "Why do you need this?",
    caption: "What changes with Grensa.AI?",
    reasonText: [
      {
        title: "50% faster responses",
        caption: "AI reduces time spent on search and formulation",
      },
      {
        title: "Fewer errors and typos",
        caption: "AI helps maintain style and correctness",
      },
      {
        title: "SLA control",
        caption: "Reminders won't let you miss important tickets",
      },
      {
        title: "Simple installation",
        caption: "Doesn't require IT resources or complex setup",
      },
    ],
  },
  pricing: {
    title: "Pricing",
    try: "Try it",
    options: [
      {
        name: "Personal",
        price1: "Free",
        perks: ["X message recommendations", "Dialogue context", "1 account"],
      },
      {
        name: "Pro Plan",
        price1: "$0.06",
        price2: "/ ticket",
        perks: [
          "Response recommendations",
          "Dialogue context",
          "SLA control",
          "TOV and quality control",
          "Up to 20 accounts",
        ],
      },
      {
        name: "Enterprise",
        price1: "Custom",
        perks: [
          "Unlimited message recommendations",
          "Dialogue context",
          "TOV and quality control",
          "X employees",
        ],
      },
    ],
  },
  footer: {
    title: "Install Grensa.AI and speed up your team!",
    caption: "Try for free – setup takes no more than 2 minutes.",
    tryFree: "Try for free",
  },
  demo: {
    title: "Callback",
    namePlaceholder: "Name",
    nameLabel: "Introduce yourself",
    phoneLabel: "Phone number",
    submitButton: "Send",
    errorMessageRequired: "Required Field",
    success: {
      title: "Request sent!",
      caption: "We will be in touch shortly",
      done: "Done",
    },
  },
};
